import { render, staticRenderFns } from "./InboundsDeliveryNoteNoticeOfLossPictures.vue?vue&type=template&id=2763fe97&scoped=true&"
import script from "./InboundsDeliveryNoteNoticeOfLossPictures.vue?vue&type=script&lang=ts&"
export * from "./InboundsDeliveryNoteNoticeOfLossPictures.vue?vue&type=script&lang=ts&"
import style0 from "./InboundsDeliveryNoteNoticeOfLossPictures.vue?vue&type=style&index=0&id=2763fe97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763fe97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VFileInput,VIcon,VImg,VProgressCircular,VRow})
